
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/essay-generator",
      function () {
        return require("private-next-pages/tools/essay-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/essay-generator"])
      });
    }
  